import React, { FC } from 'react';
import { NavLink, RouteComponentProps, Switch } from 'react-router-dom';
import { Nav } from 'reactstrap';
import { PageHeader, UserRoute, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { OAuthPage } from './oauthApps/OAuthPage';
import { WebhookPage } from './webhooks/WebhookPage';

export const DevelopersFrame: FC<RouteComponentProps> = ({ match: { path, url } }) => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('developers')}</PageHeader>
      <Nav tabs>
        <NavLink activeClassName="active" className="nav-link" exact to={url}>
          {ts('webhooks')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/oauth`}>
          {ts('oauth_applications')}
        </NavLink>
      </Nav>
      <div style={{ marginTop: '20px' }}>
        <Switch>
          <UserRoute
            component={WebhookPage}
            exact
            path={path}
            requirePermissions="webhook:manage"
          />
          <UserRoute
            component={OAuthPage}
            path={`${path}/oauth`}
            requirePermissions="oauth:manage"
          />
        </Switch>
      </div>
    </UserStateComponent>
  );
};
